import React from 'react';
import { companyInfo } from '../../data/mock';
import { Award, Users, Target, TrendingUp } from 'lucide-react';

const AboutSection = () => {
  const highlights = [
    { icon: Award, value: '15+', label: 'Years Experience' },
    { icon: Users, value: '500+', label: 'Projects Delivered' },
    { icon: Target, value: '98%', label: 'Client Satisfaction' },
    { icon: TrendingUp, value: '$10M+', label: 'Funding Recovered' }
  ];

  return (
    <section id="about" className="relative bg-black py-24 lg:py-32 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left - Image Collage */}
          <div className="relative">
            <div className="grid grid-cols-2 gap-4">
              <div className="space-y-4">
                <div className="aspect-[4/3] overflow-hidden">
                  <img 
                    src="https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?auto=format&fit=crop&w=600&q=80" 
                    alt="Business consulting"
                    className="w-full h-full object-cover hover:scale-105 transition-transform duration-700"
                  />
                </div>
                <div className="aspect-square overflow-hidden">
                  <img 
                    src="https://images.unsplash.com/photo-1738162837369-a2beec3a1d47?auto=format&fit=crop&w=600&q=80" 
                    alt="Manufacturing excellence"
                    className="w-full h-full object-cover hover:scale-105 transition-transform duration-700"
                  />
                </div>
              </div>
              <div className="space-y-4 pt-8">
                <div className="aspect-square overflow-hidden">
                  <img 
                    src="https://images.pexels.com/photos/2977565/pexels-photo-2977565.jpeg?auto=compress&w=600" 
                    alt="Team collaboration"
                    className="w-full h-full object-cover hover:scale-105 transition-transform duration-700"
                  />
                </div>
                <div className="aspect-[4/3] overflow-hidden">
                  <img 
                    src="https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?auto=format&fit=crop&w=600&q=80" 
                    alt="Innovation"
                    className="w-full h-full object-cover hover:scale-105 transition-transform duration-700"
                  />
                </div>
              </div>
            </div>
            
            {/* Floating Badge */}
            <div className="absolute -bottom-6 -right-6 bg-[#4A90A4] p-6 lg:p-8">
              <p className="text-white text-4xl lg:text-5xl font-bold">15+</p>
              <p className="text-white/80 text-sm">Years of<br />Excellence</p>
            </div>
          </div>

          {/* Right Content */}
          <div className="space-y-8">
            <div>
              <span className="text-[#4A90A4] text-sm font-semibold uppercase tracking-wider mb-4 block">About Philcan</span>
              <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
                Your Partner in <span className="text-[#4A90A4]">Operational Excellence</span>
              </h2>
            </div>
            
            <div className="space-y-6 text-white/70 text-lg leading-relaxed">
              <p>
                For over 15 years, Philcan Industries has been a trusted partner for Canadian businesses seeking to optimise their operations and unlock their full potential.
              </p>
              <p>
                We combine deep expertise in process improvement and operational excellence with a thorough understanding of innovation funding programs. This unique combination allows us to help our clients not only improve their operations but also recover significant funding for the innovative work they're already doing.
              </p>
            </div>

            {/* Stats Grid */}
            <div className="grid grid-cols-2 gap-4 pt-4">
              {highlights.map((item, index) => {
                const IconComponent = item.icon;
                return (
                  <div key={index} className="bg-white/5 border border-white/10 p-5 group hover:border-[#4A90A4]/50 transition-all duration-300">
                    <IconComponent size={24} className="text-[#4A90A4] mb-3" />
                    <div className="text-2xl font-bold text-white">{item.value}</div>
                    <div className="text-white/50 text-sm">{item.label}</div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
